<ion-header>
  <ion-toolbar>
    <ion-title>Link Brewfather batch</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ion-padding-horizontal ion-padding-top">
    <ion-text color="medium">
      <h6 style="margin-top:0;">Batch status</h6>
    </ion-text>
    @for (status of statuses; track status) {
      <ion-chip button role="button" tabindex="0"
        data-testid="fermenter-bf-status-chip" [attr.data-status]="status"
        [outline]="batchStatus() !== status"
        [color]="batchStatus() === status ? 'success' : 'default'"
        (click)="setStatus(status)" (keydown.enter)="setStatus(status)">
        {{ status }}
      </ion-chip>
    }
  </div>

  <ion-card class="ion-no-padding">
    <ion-card-content class="ion-no-padding">
      <ion-list lines="full">
        @for (item of items(); track item._id) {
          <ion-item button (click)="select(item)"
            data-testid="fermenter-bf-batch-item" [attr.data-batch-name]="displayName(item)">
            <ion-label>
              <h2>{{ displayName(item) }}</h2>
              <p>Batch #{{ item.batchNo }} — {{ item.status }}</p>
            </ion-label>
          </ion-item>
        }

        @if (loading()) {
          <ion-item lines="none">
            <ion-spinner name="crescent" slot="start"></ion-spinner>
            <ion-label>Loading batches…</ion-label>
          </ion-item>
        }

        @if (!loading() && items().length === 0) {
          <ion-item lines="none">
            <ion-label>
              <h3>No batches found</h3>
              <p>No Brewfather batches with status "{{ batchStatus() }}".</p>
            </ion-label>
          </ion-item>
        }
      </ion-list>
    </ion-card-content>
  </ion-card>
</ion-content>
